// One counter, shared by the operator's nav badge and the PDF requests page.
// Same rule as the signalements badge: whoever mounts first fetches, and a
// decision refreshes it, so the number never lies.

import { useEffect, useState } from "react";
import { superAdminApi } from "./superadmin-api";

let current: number | null = null;
const listeners = new Set<(count: number | null) => void>();

/** Re-reads the open count from the API; a failure simply hides the badge. */
export async function refreshPdfRequestCount(): Promise<void> {
  try {
    const counts = await superAdminApi.pdfRequestCounts();
    current = counts.open;
    listeners.forEach((listener) => listener(current));
  } catch {
    current = null;
    listeners.forEach((listener) => listener(null));
  }
}

/** How many clubs still wait for an integration, or null while unknown. */
export function usePdfRequestCount(): number | null {
  const [count, setCount] = useState<number | null>(current);

  useEffect(() => {
    listeners.add(setCount);
    if (current === null) void refreshPdfRequestCount();

    return () => {
      listeners.delete(setCount);
    };
  }, []);

  return count;
}
